export enum UserTransactionStatusEnum {
    SUCCESS = "0000",
    DECLINED = "2000",
    REDIRECTED = "2021",
}


